
import React from 'react';
import { cn } from '@/lib/utils';
import { Checkbox } from '@/components/ui/checkbox';
import * as LucideIcons from 'lucide-react';
import './SettingsSelect.css';

interface SettingsSelectOption {
  key: string;
  label: string;
  checked: boolean;
}

interface SettingsSelectProps {
  label: string;
  icon?: string;
  options: SettingsSelectOption[];
  onChange: (key: string, checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

const SettingsSelect: React.FC<SettingsSelectProps> = ({
  label,
  icon,
  options,
  onChange,
  disabled = false,
  className
}) => {
  // Get the icon component if specified
  const IconComponent = icon && icon in LucideIcons 
    ? LucideIcons[icon as keyof typeof LucideIcons] as React.ComponentType<{ className?: string }>
    : null;

  return (
    <div className={cn('settings-select', disabled && 'settings-select-disabled', className)}>
      <div className="settings-select-header">
        {IconComponent && <IconComponent className="settings-select-icon" />}
        <label className="settings-select-label">{label}</label>
      </div>
      <div className="settings-select-options">
        {options.map((option) => (
          <div key={option.key} className="settings-select-option">
            <Checkbox
              id={option.key}
              checked={option.checked}
              onCheckedChange={(checked) => onChange(option.key, Boolean(checked))}
              disabled={disabled}
            />
            <label 
              htmlFor={option.key} 
              className={cn(
                'settings-select-option-label',
                disabled && 'settings-select-option-label-disabled'
              )}
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SettingsSelect;
